import script from "./IGAuth.vue?vue&type=script&lang=ts"
export * from "./IGAuth.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__